import { ICSSInJSStyle } from "@fluentui/react-northstar";

import { useFluentColorScheme } from "../../../shared/theme/useColorScheme";

interface DesktopPermissionPromptStyles {
  dialogBox: ICSSInJSStyle;
  header: ICSSInJSStyle;
  description: ICSSInJSStyle;
}

export const useDesktopPermissionPromptStyles: () => DesktopPermissionPromptStyles =
  () => {
    const { white, main } = useFluentColorScheme();

    return {
      dialogBox: {
        width: "700px",
        height: "220px",
        color: white.foreground,
        backgroundColor: main.backgroundFocus2,
      },
      header: {
        width: "573px",
        height: "64px",
      },
      description: {
        width: "435px",
        height: "20px",
        color: "#CAC8C5", //TODO: update to fluent colors
      },
    };
  };
